import WorkspacesExperiments from 'bundles/epic/clients/Workspaces';

// TODO(wbowers): Remove this code when workspaces are fully supported.

export type SleuthConfig = {
  courseId: string;
  itemId: string;
  templateId?: string;
};

const defaultConfig = {
  templateId: 'IIknfCCpTv2JJ3wgqU79KA',
};

export const getSleuthConfig = (courseId: string, itemId: string): SleuthConfig | null => {
  const sleuthAssignments: Array<SleuthConfig> = WorkspacesExperiments.get('sleuthAssignments') || [];
  const config = sleuthAssignments.find((c) => c.courseId === courseId && c.itemId === itemId);

  if (config) {
    return {
      ...defaultConfig,
      ...config,
    };
  } else {
    return null;
  }
};

export const isSleuthAssignment = (courseId: string, itemId: string): boolean => {
  return !!getSleuthConfig(courseId, itemId);
};
